import { Code2, Palette, Zap } from 'lucide-react';

export function About() {
  return (
    <section id="about" className="bg-slate-950 py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12">
          {/* About Content */}
          <div>
            <h2 className="section-title mb-4">About Me</h2>
            <p className="text-slate-300 text-lg mb-4">
              Passionate Creator, Lifelong Learner
            </p>
            <p className="text-slate-400 mb-8 leading-relaxed">
              I'm a Delhi-based filmmaker and content creator passionate about visual storytelling. Specializing in cinematography, video editing, and digital content creation, I craft compelling narratives that engage and inspire audiences across all platforms.
            </p>
          </div>

          {/* Skills Grid */}
          <div className="grid grid-cols-1 gap-4">
            <div className="card-dark hover:border-cyan-500/50 transition-colors">
              <div className="flex items-start gap-4">
                <Palette className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-bold text-white mb-2">Cinematography & Filming</h3>
                  <p className="text-slate-400 text-sm">Professional camera work, composition, lighting, photography</p>
                </div>
              </div>
            </div>

            <div className="card-dark hover:border-cyan-500/50 transition-colors">
              <div className="flex items-start gap-4">
                <Code2 className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-bold text-white mb-2">Video Editing & Effects</h3>
                  <p className="text-slate-400 text-sm">Color grading, SFX, pacing, animations, film editing</p>
                </div>
              </div>
            </div>

            <div className="card-dark hover:border-cyan-500/50 transition-colors">
              <div className="flex items-start gap-4">
                <Zap className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-bold text-white mb-2">Content & Social Media</h3>
                  <p className="text-slate-400 text-sm">Storytelling, content writing, social media management</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}